import { render, staticRenderFns } from "./PaystackBeds24.vue?vue&type=template&id=1ee74084&"
import script from "./PaystackBeds24.vue?vue&type=script&lang=js&"
export * from "./PaystackBeds24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports